import { useMutation } from '@tanstack/react-query';

import { Collections } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { getCollectionKey } from '~/components/SharePrivateCollectionModal/hooks/queries/useGetCollection';
import { queryClient } from '~/swr-hooks/queryClient';
import { getShortUrlsListKey } from '~/swr-hooks/shortUrl/useListShortUrls';

export type UseAddCollectionItemsMutationParams = Required<NonNullable<Parameters<typeof Collections.Items.add>[0]>>;

export const useAddCollectionItemsMutation = () =>
  useMutation<void, unknown, UseAddCollectionItemsMutationParams>({
    mutationFn: async (params) => {
      await callAirApi(() => Collections.Items.add(params));
    },
    onSuccess: (_data, params) => {
      queryClient.invalidateQueries({ queryKey: getCollectionKey({ collectionId: params.collectionId }) });

      if (params.workspaceId) {
        queryClient.invalidateQueries({ queryKey: getShortUrlsListKey({ workspaceId: params.workspaceId }) });
      }
    },
  });
